import { call, put, select } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ApplicationState } from 'src/core/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'

import { ResponseDataClosings } from './types'
import * as ClosingsActions from './actions'
import * as RequestsActions from '../requests/actions'

export function* getClosings({
  payload: { options }
}: ReturnType<typeof ClosingsActions.getClosings>) {
  try {
    const {
      closings,
      me: { organization }
    } = yield select((state: ApplicationState) => state)

    let statusParams = ''

    if (closings.filterStatus) {
      statusParams = closings.filterStatus
        .map((status: string) => `&${status}=True`)
        .join('')
    }

    const response: ApiResponse<ResponseDataClosings> = yield call(
      api.get,
      `users/me/closings/requests?page_size=10&page=${
        options.page
      }${statusParams}${
        options.request_ids && !!options.request_ids.length
          ? `&request_ids=${options.request_ids.join(',')}&organization_id=${
              organization.organization_id
            }`
          : ''
      }`
    )

    if (response.ok) {
      yield put(ClosingsActions.getClosingsSuccess(response.data))
      yield put(
        RequestsActions.setRequestTotals({
          request_totals: response.data.request_totals
        })
      )
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(ClosingsActions.getClosingsFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getClosings', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(ClosingsActions.getClosingsFailure(message))
  }
}

export function* setClosingStatus({
  payload: { justification, request_id, request_closing_ids, status }
}: ReturnType<typeof ClosingsActions.setClosingStatus>) {
  try {
    const {
      me: { organization }
    } = yield select((state: ApplicationState) => state)

    const response: ApiResponse<ResponseDataClosings> = yield call(
      api.post,
      `/users/me/closings/requests`,
      {
        request_closings: request_closing_ids.map(request_closing_id => ({
          request_closing_id: +request_closing_id,
          request_id: +request_id,
          organization_id: organization.organization_id,
          status,
          justification
        }))
      }
    )

    if (response.ok) {
      const requestNumber = response.data?.requests?.[0]?.request_number || ''
      const message = i18n.t(
        'common.push-notifications.request-changed-successful',
        { value: requestNumber }
      )
      yield put(ClosingsActions.setClosingStatusSuccess(message))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(ClosingsActions.setClosingStatusFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga setClosingStatus', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(ClosingsActions.setClosingStatusFailure(message))
  }
}
